import type { Fetch } from '@/features/fetch/types.ts'
import { useAuthentificationStore, Utilisateur } from '@/features/auth'
import { TypesContextesAutorisesEnum, useAppContextStore } from '@/features/auth/context-app'
import { isNullOrUndefined } from '@/features/shared/tools'

export function configPreserveServerFactory() {
  let promise: PromiseLike<void> | undefined = undefined
  let lastKey: string | undefined = undefined

  return (nextFetch: Fetch): Fetch => {
    const auth = useAuthentificationStore()
    const context = useAppContextStore()

    async function fetchWrap(input: RequestInfo | URL, init?: RequestInit) {
      const method = (input as any).method ?? init?.method ?? 'GET'
      const contextCourant = context.contextCourant
      const email =
        (auth.utilisateur instanceof Utilisateur ? auth.utilisateur.impresonnaliseEmail : auth.utilisateur?.email) ??
        auth.utilisateur?.email

      // Ne traite que les requêtes GET ou nécessitant un portefeuilles
      const bypass =
        method !== 'GET' || contextCourant === TypesContextesAutorisesEnum.Aucun || isNullOrUndefined(email)
      if (bypass) return await nextFetch(input, init)

      const newKey = `${contextCourant}-${email}`
      if (lastKey !== newKey) {
        let resolvePromise: () => void | undefined
        promise = new Promise<void>((resolve) => {
          resolvePromise = resolve
          lastKey = newKey
        })

        if (isNullOrUndefined(resolvePromise!))
          throw new Error('configPreserveServer, resolvePromise should not be null')

        try {
          return await nextFetch(input, init)
        } finally {
          resolvePromise()
        }
      } else {
        await promise
        return await nextFetch(input, init)
      }
    }
    return fetchWrap
  }
}



